import * as Yup from 'yup';
import { DAYS, STANDARD_PROPERTY_TYPES, TYPE_CUSTOM_AUDIENCE } from '../../../../utils/constants';

export interface CAMPAIGN_FORM_VALUES {
  type: string;
  typeActions: string[];
  name: string;
  mlsSource: string;
  stateOrProvince: string;
  city: string;
  standardStatus: string;
  radiusInMiles: number;
  loanOfficerIds: string[];
  repeatDaysOfWeek?: DAYS[];
  hourOfDay: number;
  notes?: string;
  listingContractDateGreaterThanDays?: number;
  listingContractDateLessThanDays?: number;
  listingContractDateFrom?: string;
  listingContractDateTo?: string;
  yearBuiltFrom?: number;
  yearBuiltTo?: number;
  listPriceFrom?: number;
  listPriceTo?: number;
  subdivisionName?: string;
  listOfficeName?: string;
  standardPropertyTypes?: STANDARD_PROPERTY_TYPES[];
  seniorCommunityYN?: boolean;
  newConstructionYN?: boolean;
  ownership?: string;
  pendingTimestampTo?: string;
  pendingTimestampFrom?: string;
  offMarketTimestampTo?: string;
  offMarketTimestampFrom?: string;
  listAgentEmailOmitIfNotExists: boolean;
  daysBetweenEmails?: number;
  chimeTags?: string[];
}

export const CAMPAIGN_SCHEMA = Yup.object().shape({
  type: Yup.string().required('Required'),
  typeActions: Yup.array().of(Yup.string()).when('type', {
    is: TYPE_CUSTOM_AUDIENCE,
    then: (schema: any) => schema.min(1, "Required atleast 1 Type Action").required('Required')
  }),
  name: Yup.string().required('Required'),
  mlsSource: Yup.string().required('Required'),
  stateOrProvince: Yup.string().required('Required'),
  city: Yup.string().required('Required'),
  standardStatus: Yup.string().required('Required'),
  radiusInMiles: Yup.number().required('Required'),
  loanOfficerIds: Yup.array().min(1).required('Required'),
  repeatDaysOfWeek: Yup.array().nullable(),
  hourOfDay: Yup.number().required('Required'),
  notes: Yup.string().nullable(),
  listingContractDateGreaterThanDays: Yup.number().nullable(),
  listingContractDateLessThanDays: Yup.number().nullable(),
  listingContractDateFrom: Yup.string().nullable(),
  listingContractDateTo: Yup.string().nullable(),
  yearBuiltFrom: Yup.number().nullable(),
  yearBuiltTo: Yup.number().nullable(),
  listPriceFrom: Yup.number().nullable(),
  listPriceTo: Yup.number().nullable(),
  daysBetweenEmails: Yup.number().nullable(),
  subdivisionName: Yup.string().nullable(),
  listOfficeName: Yup.string().nullable(),
  pendingTimestampTo: Yup.string().nullable(),
  pendingTimestampFrom: Yup.string().nullable(),
  offMarketTimestampTo: Yup.string().nullable(),
  offMarketTimestampFrom: Yup.string().nullable(),
  listAgentEmailOmitIfNotExists: Yup.boolean().default(true),
  tags: Yup.array().of(Yup.string()).nullable(),
});
